module.exports = __webpack_public_path__ + "img/3.12539004.png";